var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"logo-d",attrs:{"src":require("@/assets/images/logo/isotipo2.svg"),"alt":"D"}})
}
var staticRenderFns = []

export { render, staticRenderFns }